const ALLOW_NEARBY_IS_ACTIVE_DEFAULT = true;
const CARRIER_IS_ACTIVE_DEFAULT = true;
const MULTIMODAL_TYPE = 'multi';
const DIRECT_ONLY_IS_ACTIVE_DEFAULT = false;
const FEATURE_IS_ACTIVE_DEFAULT = false;
const TIMING_DEFAULT = [0, 24];
const TRAVEL_MODES_IS_ACTIVE_DEFAULT = true;
const STATION_IS_ACTIVE_DEFAULT = true;

const RECOMMENDED = 'recommended';
const FASTEST = 'fastest';
const CHEAPEST = 'cheapest';
const EARLIEST = 'earliest';
const LATEST = 'latest';
const SORT_TYPES_ARRAY = [
    RECOMMENDED,
    FASTEST,
    CHEAPEST,
    EARLIEST,
    LATEST,
];
const DEFAULT_SORT = RECOMMENDED;

export {
    ALLOW_NEARBY_IS_ACTIVE_DEFAULT,
    CARRIER_IS_ACTIVE_DEFAULT,
    CHEAPEST,
    DEFAULT_SORT,
    DIRECT_ONLY_IS_ACTIVE_DEFAULT,
    EARLIEST,
    FASTEST,
    FEATURE_IS_ACTIVE_DEFAULT,
    LATEST,
    MULTIMODAL_TYPE,
    RECOMMENDED,
    SORT_TYPES_ARRAY,
    STATION_IS_ACTIVE_DEFAULT,
    TIMING_DEFAULT,
    TRAVEL_MODES_IS_ACTIVE_DEFAULT,
};
